// @flow
import React from 'react';
import { CheckBoxField } from '@src/formik-utils/FormFields';
import { BACKEND_FIELDNAMES } from '@streaming-projects/enums';
import { SP_USER_COMMIT_DETAILS_CONFIG_MAP } from '@streaming-projects/user-commit-details/config';

export const SPUserCommitMSKTakeoutContainer = () => {
  const { MSK_TAKEOUT } = BACKEND_FIELDNAMES;
  const { backendFieldName, displayName } = SP_USER_COMMIT_DETAILS_CONFIG_MAP.get(MSK_TAKEOUT);

  return (
    <CheckBoxField
      displayCheckBoxBelowLabel={true}
      fieldDisplayName={displayName}
      fieldName={backendFieldName}
    />
  );
};
